import React from 'react';

import { TitleWithDescription, LbDatePicker } from '@infoods/lifebase-ui';
import { useFormContext } from 'react-hook-form';
import { Moment } from 'moment';

import { ModeAwareInput } from '../../../../../../shared/components/form-components';
import { FormFieldsGrid } from '../../../FormFieldsGrid/FormFieldsGrid';
import { getRenderDate } from '../../utils/getRenderDate';
import { Mode } from '../../../../../../general-types';
import { ChallengeFormValues } from '../../../../../interfaces/ChallengeFormValues';

type ChallengeDatesSectionProps = {
  mode: Mode;
  challengeMinStartDate: Moment;
  challengeMaxStartDate: Moment | undefined;
  challengeMinEndDate: Moment;
};

export const ChallengeDatesSection = ({
  mode,
  challengeMinStartDate,
  challengeMaxStartDate,
  challengeMinEndDate,
}: ChallengeDatesSectionProps) => {
  const { control } = useFormContext<ChallengeFormValues>();

  const generalInputProps = {
    size: 'small',
    variant: 'standard',
  } as const;

  return (
    <FormFieldsGrid mode={mode}>
      <TitleWithDescription
        title="Challenge Dates"
        titleFont="body-14-bold"
        description={
          <>
            Set start / end of the challenge.
            <br />
            Activities and rankings count only inside this range.
          </>
        }
      />
      <ModeAwareInput
        mode={mode}
        control={control}
        name="importantDates.startDate"
        label="Challenge Start Date"
        renderValue={getRenderDate}
        renderEdit={(props) => (
          <LbDatePicker
            {...generalInputProps}
            {...props}
            minDate={challengeMinStartDate}
            maxDate={challengeMaxStartDate}
            rules={{
              required: 'Challenge Start Date is required',
            }}
          />
        )}
      />
      <ModeAwareInput
        mode={mode}
        control={control}
        name="importantDates.endDate"
        label="Challenge End Date"
        renderValue={getRenderDate}
        renderEdit={(props) => (
          <LbDatePicker
            {...generalInputProps}
            {...props}
            minDate={challengeMinEndDate}
            rules={{
              required: 'Challenge End Date is required',
            }}
          />
        )}
      />
    </FormFieldsGrid>
  );
};
